module.exports = __webpack_public_path__ + "static/media/service-business-desktop.14fa8b84.png";